import { MOCK_GROUP_ID } from './mockSite';
/**
 * Mock WhatsAppSession — sola identità. `startDate`, `lastMessageDate`,
 * `messageCount`, lo stato della finestra e `messages[]` NON sono qui: gli handler
 * MSW li derivano dai messaggi (mockWhatsAppMessages) con lo stesso criterio del
 * backend (DTOConverterUtil), così non possono divergere dai messaggi.
 *
 * `phoneNumber` è in forma normalizzata a cifre; `personId` collega la sessione
 * al contatto (vedi mockWhatsAppMessages per i numeri ↔ Person).
 */
export interface WhatsAppSessionMock {
  whatsAppSessionId: number;
  companyId: number;
  groupId: number;
  userId: number;
  userName: string;
  createDate: string;
  modifiedDate: string;
  phoneNumber: string;
  phoneNumberId: string;
  personId: number;
}

const audit = {
  companyId: 1,
  groupId: MOCK_GROUP_ID,
  userId: 1,
  userName: 'Sistema',
  createDate: '2026-07-01T09:00:00Z',
  modifiedDate: '2026-07-01T09:00:00Z',
};

const BUSINESS_NUMBER_ID = '1083835191482152';

export const mockWhatsAppSessions: WhatsAppSessionMock[] = [
  // Person 1 (Jader Francia) — una sessione attiva e una chiusa sullo stesso numero.
  {
    whatsAppSessionId: 71001, phoneNumber: '393391234567',
    phoneNumberId: BUSINESS_NUMBER_ID, personId: 1, ...audit,
  },
  {
    whatsAppSessionId: 71002, phoneNumber: '393391234567',
    phoneNumberId: BUSINESS_NUMBER_ID, personId: 1, ...audit,
  },
  // Person 8 (Andrea Conti) — sessione attiva.
  {
    whatsAppSessionId: 71003, phoneNumber: '393405566778',
    phoneNumberId: BUSINESS_NUMBER_ID, personId: 8, ...audit,
  },
  // Person 19 (Stefano Arteconi) — finestra aperta (71004), scaduta (71005) e in
  // attesa di risposta dopo un ricontatto via template (71006).
  {
    whatsAppSessionId: 71004, phoneNumber: '393298267164',
    phoneNumberId: BUSINESS_NUMBER_ID, personId: 19, ...audit,
  },
  {
    whatsAppSessionId: 71005, phoneNumber: '393298267164',
    phoneNumberId: BUSINESS_NUMBER_ID, personId: 19, ...audit,
  },
  {
    whatsAppSessionId: 71006, phoneNumber: '393298267164',
    phoneNumberId: BUSINESS_NUMBER_ID, personId: 19, ...audit,
  },
];
